<script setup lang="ts">
import {
  CollapsibleContent,
  CollapsibleRoot,
  CollapsibleTrigger,
} from "reka-ui"
import { availableFeatures } from "~/utils/features"

const { devState } = useDeveloperTools()
const {
  clearFeatureOverrides,
  featureOverrides,
  hasFeature,
  hasSessionFeature,
  setFeatureOverride,
} = useAuth()

const hasFeatureOverrides = computed(
  () => Object.keys(featureOverrides.value).length > 0,
)

function hideDevTools() {
  devState.value = {
    loading: false,
    empty: false,
    loadingDelay: 0,
    expanded: false,
    hidden: true,
  }
}
</script>
<template>
  <DevOnly>
    <CollapsibleRoot
      v-if="!devState.hidden"
      v-model:open="devState.expanded"
      class="fixed right-2 bottom-2 z-50 overflow-hidden rounded-lg border border-zinc-100 bg-white/90 px-2 shadow-sm backdrop-blur-sm"
      :class="{
        'max-h-[min(42rem,calc(100vh-1rem))] w-96 max-w-[calc(100vw-1rem)] py-2':
          devState.expanded,
      }"
    >
      <div v-if="!devState.expanded" class="flex flex-row gap-1">
        <CollapsibleTrigger as-child>
          <button class="text-sm leading-0 text-zinc-500">
            Show Dev Tools
          </button>
        </CollapsibleTrigger>
        <button class="text-sm text-red-500 underline" @click="hideDevTools">
          <SvgoPikaClose class="size-4" />
        </button>
      </div>
      <CollapsibleContent
        class="grid max-h-[min(41rem,calc(100vh-2rem))] grid-rows-[auto_minmax(0,1fr)_auto] gap-4"
      >
        <div class="flex items-center justify-between">
          <h3 class="text-lg font-bold">Feature flags</h3>
          <div class="space-x-2">
            <CollapsibleTrigger as-child>
              <button class="text-sm text-blue-500 underline">Collapse</button>
            </CollapsibleTrigger>
            <button
              class="text-sm text-red-500 underline"
              @click="hideDevTools"
            >
              Hide
            </button>
          </div>
        </div>
        <div class="min-h-0 overflow-y-auto pr-1">
          <div
            v-for="feature in availableFeatures"
            :key="feature"
            class="flex items-center justify-between gap-3 border-t border-zinc-100 py-2 first:border-t-0"
          >
            <div class="min-w-0">
              <div class="truncate text-sm font-medium text-zinc-900">
                {{ feature }}
              </div>
              <div
                v-if="
                  featureOverrides[feature] != undefined &&
                  featureOverrides[feature] != hasSessionFeature(feature)
                "
                class="text-xs text-amber-600"
              >
                Overridden
              </div>
            </div>
            <FormToggle
              :model-value="hasFeature(feature)"
              @update:model-value="setFeatureOverride(feature, Boolean($event))"
            />
          </div>
        </div>
        <FormButton
          :disabled="!hasFeatureOverrides"
          variant="secondary"
          @click="clearFeatureOverrides"
        >
          Reset feature flags
        </FormButton>
      </CollapsibleContent>
    </CollapsibleRoot>
  </DevOnly>
</template>
